"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _grid = require("../grid");

var _default = _grid.Row;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/row/index.js
// module id = 299
// module chunks = 0